import {DISCOVER_FEED_URI} from '#/lib/constants'
import {type NewsCategory} from '#/features/news/types'

export const NEWS_CATEGORIES: NewsCategory[] = [
  {
    id: 'top',
    title: 'Top Stories',
    slug: 'topstories',
    feedUriOrKey: DISCOVER_FEED_URI,
  },
  {
    id: 'tech',
    title: 'Tech',
    slug: 'tech',
    feedUriOrKey: DISCOVER_FEED_URI,
  },
  {
    id: 'culture',
    title: 'Culture',
    slug: 'culture',
    feedUriOrKey: DISCOVER_FEED_URI,
  },
]

export const DEFAULT_NEWS_FAVORITES = NEWS_CATEGORIES.map(category => category.id)
